import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('muzi_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Token expired or invalid
      const path = window.location.pathname;
      if (path !== '/' && localStorage.getItem('muzi_token')) {
        localStorage.removeItem('muzi_token');
        localStorage.removeItem('muzi_user');
      }
    }
    return Promise.reject(err);
  }
);

// ===== Auth =====
export const authApi = {
  register: (data) => api.post('/auth/register', data).then((r) => r.data),
  login: (data) => api.post('/auth/login', data).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
  resetPassword: (data) => api.post('/auth/reset-password', data).then((r) => r.data),
};

// ===== Admin diagnostics (founder only) =====
export const diagnosticsApi = {
  summary: (days = 7) => api.get(`/admin/diagnostics/summary?days=${days}`).then((r) => r.data),
  clear: () => api.delete('/admin/diagnostics/clear').then((r) => r.data),
};

// ===== Users =====
export const usersApi = {
  updateMe: (data) => api.put('/users/me', data).then((r) => r.data),
  leaderboard: (limit = 20) => api.get(`/users/leaderboard?limit=${limit}`).then((r) => r.data),
  toggleFollow: (id) => api.post(`/users/follow/${id}`).then((r) => r.data),
};

// ===== Battles =====
export const battlesApi = {
  save: (data) => api.post('/battles', data).then((r) => r.data),
  myHistory: (limit = 20) => api.get(`/battles/me?limit=${limit}`).then((r) => r.data),
};

// ===== AI =====
export const aiApi = {
  validateWord: (data) => api.post('/ai/validate-word', data).then((r) => r.data),
  coachReaction: (data) => api.post('/ai/coach-reaction', data).then((r) => r.data),
  generateAvatar: (data) => api.post('/ai/avatar', data, { timeout: 60000 }).then((r) => r.data),
};

// ===== Shop =====
export const shopApi = {
  buy: (data) => api.post('/shop/buy', data).then((r) => r.data),
  owned: () => api.get('/shop/owned').then((r) => r.data),
  topup: (data) => api.post('/shop/topup', data).then((r) => r.data),
};
